import { Component, OnInit, Input } from '@angular/core';
import {UserService} from '../servies/user/user.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {
  @Input() loginname: string;
  logged_in_username: string="";
  constructor(private _userService: UserService) {
    this.logged_in_username= sessionStorage.getItem('loggedinname');
   }

  ngOnInit() {
  }

  public logout() {        
    this.logged_in_username = null;
    this._userService.logout();
  }
}
